import React from "react";

const Caterpie = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-0.9 0.0 133.25 132.85"
      {...rest}
    >
      <g>
        <path
          fill="#0d131a"
          d="M80.5 78.1 L57.55 78.1 57.55 51.1 80.5 51.1 80.5 78.1"
        />
        <path
          fill="#0d131a"
          d="M0.5 78.55 Q1.75 73.85 4.65 73.2 8.05 72.45 11.1 76.7 13.8 80.5 14.8 85.9 15.8 91.25 14.6 97.2 13.65 102.15 11.95 104.65 L11.15 105.75 Q9.45 105.05 6.75 102.05 2.85 97.65 1.25 91.85 -0.9 84.0 0.5 78.55"
        />
        <path
          fill="#f0e78e"
          d="M2.65 89.7 Q1.35 84.25 1.9 79.75 2.5 74.8 5.2 74.25 7.4 73.8 9.7 77.15 12.15 80.75 13.25 87.05 13.85 90.3 13.4 94.9 12.95 100.45 11.15 104.4 8.45 102.55 6.1 98.4 3.8 94.35 2.65 89.7"
        />
        <path
          fill="#c9c279"
          d="M2.7 76.6 Q1.95 87.9 6.95 95.65 8.85 98.55 10.7 99.45 12.5 100.35 12.9 98.65 12.25 101.95 11.15 104.4 8.45 102.55 6.1 98.4 3.8 94.35 2.65 89.7 1.75 86.05 1.75 82.55 1.7 78.8 2.7 76.6"
        />
        <path
          fill="#0d131a"
          d="M15.1 107.35 L13.4 108.7 11.2 109.6 Q8.8 109.25 8.8 106.6 8.75 104.0 10.75 103.15 12.75 102.25 14.35 103.75 16.0 105.25 15.1 107.35"
        />
        <path
          fill="#f0e78e"
          d="M14.2 105.15 Q14.65 106.05 13.8 107.1 L12.8 107.95 11.9 108.3 Q10.85 108.5 10.2 107.75 9.7 107.2 9.9 106.05 10.05 104.85 10.95 104.25 11.6 103.85 12.55 104.0 13.7 104.15 14.2 105.15"
        />
        <path
          fill="#c9c279"
          d="M14.2 105.15 Q14.65 106.05 13.8 107.1 L12.8 107.95 11.9 108.3 Q10.85 108.5 10.2 107.75 9.65 107.15 9.9 106.05 L12.15 106.2 Q13.45 105.55 13.2 104.2 13.85 104.45 14.2 105.15"
        />
        <path
          fill="#0d131a"
          d="M76.25 108.75 Q78.2 106.9 81.4 106.9 85.05 106.9 87.45 108.55 90.55 110.7 90.55 115.25 90.55 118.25 87.6 120.85 84.6 123.55 81.05 123.35 78.1 123.2 76.2 121.3 74.05 119.05 74.05 115.0 74.05 110.9 76.25 108.75"
        />
        <path
          fill="#f0e78e"
          d="M76.75 109.65 Q78.6 107.2 81.5 107.2 84.5 107.2 86.65 109.35 88.85 111.6 88.85 115.05 88.85 117.95 86.2 120.05 83.7 122.0 80.65 122.0 78.5 122.0 76.7 119.75 74.95 117.55 74.95 115.05 74.95 111.95 76.75 109.65"
        />
        <path
          fill="#c9c279"
          d="M80.65 122.0 Q78.5 122.0 76.7 119.75 74.95 117.55 74.95 115.05 74.95 111.95 76.75 109.65 78.6 107.2 81.5 107.2 L83.75 107.55 82.55 107.45 Q79.85 107.45 77.95 109.35 76.05 111.25 76.05 113.95 76.05 116.65 77.95 118.6 79.85 120.5 82.55 120.5 84.7 120.5 86.45 119.2 88.15 117.95 88.8 115.95 88.35 118.5 85.85 120.3 83.45 122.0 80.65 122.0"
        />
        <path
          fill="#0d131a"
          d="M73.0 97.9 L72.35 121.15 Q68.15 127.7 60.8 130.2 54.1 132.5 40.55 132.7 29.45 132.85 21.55 128.15 13.1 123.15 10.9 114.0 10.1 110.45 11.85 108.2 13.8 105.75 17.45 107.3 L21.1 108.65 27.7 109.2 Q36.05 108.95 40.45 103.0 44.8 97.05 43.85 87.1 L58.7 79.9 73.0 97.9"
        />
        <path
          fill="#6cba5a"
          d="M24.25 110.25 L22.65 110.9 Q20.85 112.0 19.65 114.25 18.45 116.55 18.75 119.25 L19.35 121.55 17.35 120.95 Q16.0 120.5 15.2 119.75 13.95 118.55 13.1 116.6 12.3 114.65 12.15 112.45 12.0 110.0 13.35 108.65 L17.1 108.55 20.0 109.7 Q22.6 110.5 24.25 110.25"
        />
        <path
          fill="#5da24d"
          d="M12.5 114.6 Q13.4 116.55 15.7 117.25 L18.75 117.05 Q18.45 119.55 19.35 121.55 L17.35 120.95 Q16.0 120.5 15.2 119.75 13.2 117.8 12.5 114.6"
        />
        <path
          fill="#6cba5a"
          d="M33.4 109.95 L32.25 111.55 Q31.1 113.6 31.1 115.55 31.1 117.65 31.95 119.6 32.65 121.1 33.35 121.7 34.1 122.4 33.2 122.55 L27.7 123.0 Q24.05 123.0 22.0 121.6 20.05 120.25 20.05 117.95 20.05 115.3 22.05 112.95 23.75 110.95 25.4 110.55 L29.35 110.3 31.7 109.8 Q33.25 109.4 33.4 109.95"
        />
        <path
          fill="#5da24d"
          d="M20.05 117.5 Q20.8 119.45 25.55 120.1 30.35 120.7 31.7 118.9 32.4 120.85 33.35 121.7 34.1 122.4 33.2 122.55 L27.7 123.0 Q24.05 123.0 22.0 121.6 20.05 120.25 20.05 117.95 L20.05 117.5"
        />
        <path
          fill="#6cba5a"
          d="M45.9 118.65 Q41.9 121.05 38.75 121.55 35.5 121.95 33.8 119.9 32.4 118.2 32.4 115.35 32.4 113.6 32.9 112.4 33.4 111.05 34.7 109.8 L38.85 106.55 Q41.9 104.05 42.95 101.8 L43.35 101.4 43.7 101.8 Q44.05 103.65 45.6 105.7 48.45 109.5 54.1 111.35 L52.2 113.7 Q49.55 116.5 45.9 118.65"
        />
        <path
          fill="#5da24d"
          d="M41.6 117.05 Q47.3 113.4 46.3 106.55 49.1 109.75 54.1 111.35 L52.2 113.7 Q49.55 116.5 45.9 118.65 41.9 121.05 38.75 121.55 34.5 122.1 33.05 118.65 36.65 120.15 41.6 117.05"
        />
        <path
          fill="#6cba5a"
          d="M58.85 82.6 L60.45 100.4 58.6 106.75 54.8 109.5 Q51.45 109.5 48.0 106.2 44.4 102.8 44.4 99.15 44.4 98.3 44.75 96.6 L45.3 93.7 Q46.0 89.35 45.9 88.3 L53.95 82.6 58.85 82.6"
        />
        <path
          fill="#5da24d"
          d="M58.85 82.6 L60.45 100.4 58.6 106.75 54.8 109.5 Q52.95 109.5 50.75 108.25 48.6 107.05 46.95 105.1 50.5 105.2 52.55 102.7 54.35 100.5 54.55 97.05 54.8 93.8 53.55 91.25 52.25 88.55 50.0 88.3 L53.95 82.6 58.85 82.6"
        />
        <path
          fill="#c9c279"
          d="M67.6 116.5 Q70.6 120.55 69.8 121.85 67.7 125.2 63.55 127.4 59.5 129.55 55.8 129.55 52.6 129.55 49.35 127.05 46.2 124.6 45.3 121.7 44.95 120.45 46.55 119.65 L51.95 115.55 64.45 112.7 67.6 116.5"
        />
        <path
          fill="#c9c279"
          d="M53.1 129.95 Q43.9 131.85 39.05 131.3 36.45 131.0 34.9 128.5 33.35 126.0 34.55 124.25 34.85 123.85 35.3 123.65 L36.75 123.15 39.3 122.6 44.05 121.0 45.5 124.5 Q48.0 128.35 53.1 129.95"
        />
        <path
          fill="#c9c279"
          d="M35.95 130.95 Q27.75 130.4 23.1 127.45 21.65 126.4 21.1 124.85 20.6 123.35 21.3 123.3 L26.35 124.05 Q29.95 124.3 33.25 123.9 32.35 126.05 33.4 128.15 34.2 129.85 35.95 130.95"
        />
        <path
          fill="#c9c279"
          d="M20.7 126.15 Q18.25 124.65 16.65 122.55 16.4 122.25 16.55 122.0 L17.2 121.9 19.7 122.8 Q19.3 123.5 19.8 124.7 L20.7 126.15"
        />
        <path
          fill="#0d131a"
          d="M43.5 36.75 Q46.15 39.15 52.75 46.45 58.05 51.75 61.75 58.8 65.15 65.25 65.15 68.95 65.15 71.8 63.55 74.55 L61.5 77.45 60.0 80.3 57.75 84.0 Q55.65 87.05 53.45 88.15 51.2 89.25 46.9 89.25 39.6 89.25 32.3 78.75 24.8 68.05 24.8 56.75 24.8 49.45 28.35 42.55 31.7 36.05 35.7 34.35 39.2 32.9 43.5 36.75"
        />
        <path
          fill="#6cba5a"
          d="M36.1 36.5 L40.0 36.35 48.3 43.9 53.55 50.7 Q59.0 57.9 60.15 59.85 63.9 66.3 63.9 68.7 63.9 70.8 62.35 73.35 L60.4 76.0 58.65 79.05 56.5 82.8 Q53.15 87.85 47.85 87.85 40.7 87.85 33.9 78.25 26.9 68.35 26.9 57.1 26.9 50.7 29.95 43.65 33.05 36.5 36.1 36.5"
        />
        <path
          fill="#5da24d"
          d="M63.9 68.7 Q63.9 70.8 62.35 73.35 L60.4 76.0 58.65 79.05 56.5 82.8 Q53.15 87.85 47.85 87.85 45.3 87.85 42.15 86.15 47.95 87.8 50.15 84.05 52.5 79.95 48.8 71.9 48.35 70.9 43.95 65.05 39.65 59.4 38.2 55.85 L54.4 51.85 60.15 59.85 Q63.9 66.3 63.9 68.7"
        />
        <path
          fill="#0d131a"
          d="M71.8 87.2 Q80.1 87.2 84.25 91.15 88.6 95.25 88.6 103.9 88.6 110.1 82.05 116.15 75.3 122.45 67.7 122.45 61.8 122.45 58.55 118.2 55.3 113.9 55.3 106.15 55.3 99.9 59.95 93.85 65.1 87.2 71.8 87.2"
        />
        <path
          fill="#f0e78e"
          d="M71.95 88.4 Q78.75 88.4 82.75 92.25 87.1 96.4 87.1 104.1 87.1 109.75 80.5 115.6 73.95 121.45 67.7 121.45 62.8 121.45 59.7 117.5 56.5 113.45 56.5 106.65 56.5 100.8 61.15 94.85 66.1 88.4 71.95 88.4"
        />
        <path
          fill="#c9c279"
          d="M59.05 98.05 Q61.65 93.3 65.45 90.65 L72.85 95.95 72.35 102.25 Q69.75 102.45 67.2 104.0 64.8 105.45 63.6 107.35 62.7 108.9 59.8 110.1 L57.05 111.0 56.9 110.95 Q56.5 108.85 56.5 106.65 56.5 102.65 59.05 98.05"
        />
        <path
          fill="#c9c279"
          d="M66.5 117.4 Q73.15 117.4 78.75 113.85 84.2 110.4 87.1 104.65 86.75 110.25 80.25 115.85 73.8 121.45 67.7 121.45 64.85 121.45 62.55 120.05 60.2 118.65 58.7 116.05 62.4 117.4 66.5 117.4"
        />
        <path
          fill="#0d131a"
          d="M59.3 106.4 Q63.6 106.4 66.0 109.15 68.1 111.55 68.0 114.9 67.9 117.85 65.35 120.3 62.65 122.85 59.05 122.85 56.05 122.85 53.8 120.7 51.25 118.25 51.25 114.35 51.25 111.35 53.35 109.0 55.7 106.4 59.3 106.4"
        />
        <path
          fill="#f0e78e"
          d="M59.5 107.7 Q62.55 107.7 64.6 109.75 66.5 111.7 66.5 114.25 66.5 117.05 64.35 119.35 62.15 121.75 59.25 121.75 56.8 121.75 54.75 119.7 52.65 117.7 52.65 115.25 52.65 111.75 54.6 109.7 56.45 107.7 59.5 107.7"
        />
        <path
          fill="#c9c279"
          d="M52.8 113.65 Q53.85 116.3 56.15 117.9 58.55 119.55 61.45 119.55 63.2 119.55 64.7 118.95 62.4 121.75 59.25 121.75 56.8 121.75 54.75 119.7 52.65 117.7 52.65 115.25 52.65 114.4 52.8 113.65"
        />
        <path
          fill="#0d131a"
          d="M92.1 98.55 Q85.4 103.0 76.55 103.0 68.1 103.0 63.25 98.25 58.2 93.35 58.2 84.4 58.2 78.25 63.65 73.65 69.45 68.7 78.25 68.7 88.85 68.7 94.05 74.25 98.75 79.25 98.75 88.4 98.75 94.1 92.1 98.55"
        />
        <path
          fill="#f0e78e"
          d="M90.45 97.5 Q84.3 101.55 76.8 101.55 68.4 101.55 63.95 96.95 59.65 92.5 59.65 84.5 59.65 79.45 65.3 74.9 71.15 70.2 78.0 70.2 87.65 70.2 92.2 74.4 96.85 78.6 96.85 87.7 96.85 93.3 90.45 97.5"
        />
        <path
          fill="#c9c279"
          d="M90.0 91.65 Q94.55 87.75 96.2 81.65 96.85 84.25 96.85 87.7 96.85 93.3 90.45 97.5 84.3 101.55 76.8 101.55 68.4 101.55 63.95 96.95 59.65 92.5 59.65 84.5 59.65 81.5 62.05 78.3 62.8 85.6 67.75 90.6 72.75 95.6 79.45 95.6 85.3 95.6 90.0 91.65"
        />
        <path
          fill="#c9c279"
          d="M95.1 78.35 Q91.25 80.0 87.15 80.0 82.2 80.0 77.85 77.7 73.65 75.5 70.8 71.65 74.45 70.2 78.0 70.2 91.25 70.2 95.1 78.35"
        />
        <path
          fill="#0d131a"
          d="M65.85 80.45 Q69.4 80.45 72.1 83.0 74.95 85.75 74.95 89.85 74.95 94.05 71.75 96.6 68.75 99.0 64.35 99.0 60.8 99.0 58.3 96.4 55.7 93.7 55.7 89.65 55.7 85.5 58.6 82.95 61.45 80.45 65.85 80.45"
        />
        <path
          fill="#f0e78e"
          d="M65.45 81.75 Q69.1 81.75 71.4 84.3 73.5 86.65 73.5 89.85 73.5 93.2 70.9 95.5 68.35 97.75 64.75 97.75 61.45 97.75 59.2 95.45 57.0 93.15 57.0 89.85 57.0 86.4 59.35 84.1 61.75 81.75 65.45 81.75"
        />
        <path
          fill="#c9c279"
          d="M66.05 94.35 Q70.4 94.35 73.35 91.3 72.8 94.1 70.35 95.95 67.9 97.75 64.75 97.75 61.45 97.75 59.2 95.45 57.0 93.15 57.0 89.85 L57.05 89.0 Q58.4 91.45 60.75 92.9 63.15 94.35 66.05 94.35"
        />
        <path
          fill="#0d131a"
          d="M87.55 87.95 Q88.65 85.55 90.35 84.0 92.25 82.25 94.15 82.25 96.55 82.25 98.15 84.2 99.85 86.2 99.85 89.4 99.85 93.15 97.0 95.95 94.2 98.7 90.5 98.7 87.1 98.7 86.4 95.1 85.75 91.85 87.55 87.95"
        />
        <path
          fill="#f0e78e"
          d="M93.95 83.3 Q95.85 83.3 97.1 85.05 98.35 86.8 98.35 89.2 98.35 92.55 96.05 94.85 93.7 97.2 90.4 97.2 89.2 97.2 88.35 96.3 87.4 95.3 87.4 93.6 87.4 90.5 89.6 86.95 91.85 83.3 93.95 83.3"
        />
        <path
          fill="#c9c279"
          d="M87.4 93.7 Q89.45 95.65 92.4 95.65 94.55 95.65 96.3 94.55 93.95 97.2 90.4 97.2 89.2 97.2 88.4 96.35 87.45 95.35 87.4 93.7"
        />
        <path
          fill="#0d131a"
          d="M97.05 77.35 Q87.5 77.35 79.65 72.3 72.15 67.5 72.15 62.3 72.15 59.8 72.45 59.2 71.25 60.8 68.25 62.4 62.35 65.55 53.65 65.55 45.55 65.55 40.3 58.0 34.85 50.25 34.85 37.85 34.85 20.35 48.65 9.6 61.0 0.0 77.5 0.0 92.6 0.0 106.55 10.45 121.55 21.7 121.55 36.15 121.55 44.95 114.65 50.8 L115.75 53.05 Q116.85 56.0 116.85 59.4 116.85 66.15 112.25 71.25 106.75 77.35 97.05 77.35"
        />
        <path
          fill="#6cba5a"
          d="M96.7 45.4 Q115.0 45.4 115.0 59.5 115.0 66.15 109.8 71.0 104.55 75.9 97.35 75.9 87.8 75.9 80.05 70.4 73.45 65.7 73.45 62.2 L73.55 59.5 73.65 58.6 79.0 53.8 Q83.0 49.9 87.6 47.65 92.35 45.4 96.7 45.4"
        />
        <path
          fill="#5da24d"
          d="M93.15 68.8 L94.35 68.75 94.35 75.75 Q85.85 74.9 79.2 69.75 73.45 65.3 73.45 62.2 L73.55 59.5 73.65 58.6 76.05 56.55 Q77.9 61.95 82.5 65.35 87.25 68.8 93.15 68.8"
        />
        <path
          fill="#6cba5a"
          d="M105.95 12.25 Q119.55 23.05 119.55 36.15 119.55 41.8 116.6 46.15 L113.65 49.35 Q111.35 46.6 106.55 45.2 102.25 43.95 96.6 43.95 89.75 43.95 83.35 48.15 81.7 49.25 73.15 56.55 68.45 60.6 64.2 62.15 59.8 63.75 53.1 63.75 46.15 63.75 41.5 56.2 36.95 48.7 36.95 37.75 36.95 21.65 49.4 11.3 61.0 1.65 77.15 1.65 92.55 1.65 105.95 12.25"
        />
        <path
          fill="#5da24d"
          d="M50.55 57.35 Q61.55 62.05 73.5 56.3 L73.15 56.55 Q68.45 60.6 64.2 62.15 59.8 63.75 53.1 63.75 46.6 63.75 42.1 57.1 37.65 50.6 37.05 40.65 39.6 52.6 50.55 57.35"
        />
        <path
          fill="#0d131a"
          d="M58.45 11.75 Q65.45 11.75 70.35 17.05 74.75 21.8 74.75 27.4 74.75 33.9 70.5 38.3 65.8 43.2 57.65 43.2 51.65 43.2 47.2 38.7 42.7 34.1 42.7 27.75 42.7 21.25 47.35 16.55 52.0 11.75 58.45 11.75"
        />
        <path
          fill="#f9be00"
          d="M58.8 13.55 Q65.05 13.55 69.25 18.35 72.95 22.6 72.95 27.5 72.95 33.35 68.7 37.5 64.2 41.95 57.35 41.6 51.95 41.35 48.25 37.3 44.5 33.2 44.5 27.3 44.5 21.5 48.55 17.55 52.65 13.55 58.8 13.55"
        />
        <path
          fill="#0d131a"
          d="M58.0 38.05 Q53.65 38.05 50.55 34.95 47.45 31.85 47.45 27.5 47.45 23.1 50.55 20.0 53.65 16.9 58.0 16.9 62.4 16.9 65.5 20.0 68.6 23.1 68.6 27.5 68.6 31.85 65.5 34.95 62.4 38.05 58.0 38.05"
        />
        <path
          fill="#0d131a"
          d="M124.55 12.3 Q128.2 11.55 130.2 14.35 132.35 17.25 130.9 20.2 129.25 23.55 123.15 26.15 114.15 30.1 111.35 31.7 109.3 32.85 108.65 33.65 107.95 34.45 107.15 36.6 104.95 42.45 100.7 41.8 97.95 41.4 96.75 39.55 96.0 38.45 95.55 35.8 L94.95 32.4 Q94.55 31.2 93.0 30.0 91.6 28.9 84.4 25.15 77.0 21.25 75.5 20.15 71.85 17.45 71.5 13.75 71.25 10.75 72.9 8.85 74.6 6.85 77.45 6.7 80.3 6.6 82.9 8.45 L88.35 13.0 95.25 18.8 Q100.8 23.05 103.15 23.1 106.35 23.2 115.95 16.6 121.3 12.95 124.55 12.3"
        />
        <path
          fill="#da4e70"
          d="M122.05 14.8 Q124.4 13.55 126.25 13.7 127.95 13.9 128.9 15.15 130.35 17.1 129.3 19.3 128.2 21.65 124.6 23.4 116.65 27.25 111.4 29.95 108.95 31.2 108.05 32.1 106.75 33.3 106.0 35.55 105.0 38.3 103.75 39.4 102.45 40.5 100.6 40.15 98.75 39.8 98.05 38.75 97.4 37.75 97.15 35.1 96.9 32.85 96.15 31.45 95.2 29.75 92.95 28.15 L87.75 25.2 79.4 20.65 Q74.85 18.05 73.6 15.15 72.5 12.5 74.15 10.2 75.75 7.95 78.65 8.5 81.9 9.1 86.25 13.15 90.45 17.1 95.0 20.35 100.7 24.4 103.25 24.4 106.2 24.4 112.2 20.85 L122.05 14.8"
        />
        <path
          fill="#b8405f"
          d="M129.7 17.15 Q129.9 18.8 128.65 20.4 127.3 22.1 124.6 23.4 116.65 27.25 111.4 29.95 108.95 31.2 108.05 32.1 106.75 33.3 106.0 35.55 105.0 38.3 103.75 39.4 102.45 40.5 100.6 40.15 98.75 39.8 98.05 38.75 97.4 37.75 97.15 35.1 96.9 32.85 96.15 31.45 95.2 29.75 92.95 28.15 L87.75 25.2 79.4 20.65 Q75.9 18.7 74.35 16.45 72.95 14.45 73.25 12.45 73.1 14.7 84.75 21.05 96.55 27.45 102.6 28.05 107.3 28.55 118.35 24.0 129.3 19.5 129.7 17.15"
        />
        <path
          fill="#0d131a"
          d="M98.5 55.75 Q104.8 55.75 108.8 59.15 112.55 62.3 112.55 66.9 112.55 69.8 109.4 72.8 105.45 76.6 99.05 76.85 93.2 77.05 89.0 74.75 84.15 72.1 84.15 67.2 84.15 62.5 88.4 59.15 92.65 55.75 98.5 55.75"
        />
        <path
          fill="#6cba5a"
          d="M98.35 57.2 Q103.2 57.1 106.8 59.6 110.75 62.3 110.75 66.65 110.75 70.85 107.35 73.15 104.05 75.35 98.25 75.35 92.4 75.35 89.05 72.85 86.05 70.6 86.05 67.25 86.05 63.5 89.2 60.6 92.7 57.35 98.35 57.2"
        />
        <path
          fill="#8a969d"
          d="M57.85 27.0 Q55.4 27.75 53.3 26.95 51.15 26.2 50.6 24.35 50.0 22.5 51.3 20.6 52.6 18.75 55.0 18.0 57.45 17.25 59.55 18.0 61.7 18.8 62.3 20.65 62.85 22.55 61.6 24.35 60.3 26.2 57.85 27.0"
        />
        <path
          fill="#5da24d"
          d="M86.4 69.4 Q90.55 72.55 97.7 73.1 104.75 73.65 109.3 71.25 106.25 75.35 98.25 75.35 93.4 75.35 90.25 73.6 87.35 72.0 86.4 69.4"
        />
        <path
          fill="#5da24d"
          d="M86.4 69.4 Q90.55 72.55 97.7 73.1 104.75 73.65 109.3 71.25 106.25 75.35 98.25 75.35 93.4 75.35 90.25 73.6 87.35 72.0 86.4 69.4"
        />
        <path
          fill="#d6e6ae"
          d="M39.7 62.2 Q42.55 63.8 44.1 67.05 45.75 70.5 45.4 73.7 45.05 76.85 42.8 78.1 40.6 79.35 37.55 77.85 34.5 76.3 32.65 73.0 30.8 69.7 31.2 66.45 31.55 63.2 33.8 61.95 36.55 60.4 39.7 62.2"
        />
        <path
          fill="#6cba5a"
          d="M39.25 64.55 Q41.45 65.75 42.55 68.2 43.85 70.8 43.55 73.2 43.3 75.55 41.6 76.5 L37.65 76.3 Q35.35 75.15 33.95 72.65 32.6 70.2 32.9 67.7 33.15 65.3 34.85 64.35 36.9 63.2 39.25 64.55"
        />
        <path
          fill="#d6e6ae"
          d="M52.95 96.7 Q52.8 98.4 51.85 99.55 50.95 100.7 49.7 100.7 48.4 100.7 47.5 99.45 46.55 98.15 46.6 96.45 46.65 94.75 47.6 93.55 48.55 92.35 49.8 92.4 51.35 92.4 52.25 93.8 53.05 95.1 52.95 96.7"
        />
        <path
          fill="#6cba5a"
          d="M52.0 96.7 Q51.9 98.0 51.2 98.85 50.5 99.7 49.55 99.7 48.6 99.7 47.9 98.75 47.2 97.75 47.25 96.5 47.25 95.2 48.0 94.3 48.7 93.45 49.65 93.45 50.8 93.5 51.45 94.55 52.1 95.5 52.0 96.7"
        />
        <path
          fill="#d6e6ae"
          d="M42.1 114.95 Q40.55 116.05 38.95 116.1 37.3 116.15 36.45 115.1 35.55 114.05 35.95 112.4 36.35 110.7 37.8 109.5 39.25 108.3 40.95 108.25 42.55 108.2 43.45 109.25 44.55 110.55 44.05 112.3 43.55 113.9 42.1 114.95"
        />
        <path
          fill="#6cba5a"
          d="M41.5 114.25 Q40.3 115.1 39.1 115.15 37.8 115.15 37.15 114.35 36.45 113.55 36.8 112.3 37.1 111.0 38.2 110.05 39.3 109.15 40.6 109.1 41.85 109.05 42.55 109.9 43.35 110.9 42.95 112.25 42.6 113.45 41.5 114.25"
        />
        <path
          fill="#d6e6ae"
          d="M26.35 117.6 Q25.05 117.75 24.05 117.2 23.05 116.65 22.85 115.7 22.65 114.75 23.5 113.85 24.35 113.0 25.6 112.75 26.9 112.55 27.95 113.1 29.0 113.6 29.15 114.6 29.35 115.75 28.45 116.65 27.6 117.45 26.35 117.6"
        />
        <path
          fill="#6cba5a"
          d="M26.15 116.9 L24.4 116.6 Q23.6 116.2 23.5 115.5 23.4 114.75 24.0 114.1 24.6 113.45 25.6 113.3 26.55 113.1 27.35 113.55 28.1 113.95 28.25 114.65 28.4 115.5 27.7 116.15 27.1 116.8 26.15 116.9"
        />
        <path
          fill="#d6e6ae"
          d="M14.95 114.6 Q14.0 113.95 13.7 113.05 13.35 112.15 13.75 111.45 14.15 110.75 15.15 110.65 16.15 110.55 17.1 111.1 18.05 111.65 18.45 112.6 18.8 113.5 18.4 114.2 17.85 115.05 16.8 115.1 15.85 115.15 14.95 114.6"
        />
        <path
          fill="#6cba5a"
          d="M15.25 113.95 Q14.55 113.5 14.3 112.85 14.05 112.25 14.35 111.75 L15.35 111.15 Q16.05 111.05 16.75 111.45 17.45 111.85 17.7 112.5 17.95 113.15 17.65 113.7 17.3 114.3 16.55 114.35 15.85 114.4 15.25 113.95"
        />
        <path
          fill="#edadb5"
          d="M127.9 16.1 Q127.85 16.7 127.25 17.1 126.65 17.5 125.85 17.4 125.05 17.35 124.55 16.85 124.05 16.35 124.1 15.7 124.15 15.1 124.75 14.7 125.35 14.35 126.15 14.4 126.95 14.5 127.45 14.95 128.0 15.45 127.9 16.1"
        />
        <path
          fill="#edadb5"
          d="M89.25 19.1 Q89.1 19.3 85.2 16.95 81.5 14.7 79.75 13.4 77.4 11.65 77.9 10.95 78.55 10.3 80.95 12.05 83.25 13.8 85.95 16.05 89.4 18.85 89.25 19.1"
        />
      </g>
    </svg>
  );
};

export default Caterpie;
